import {validSignalDraft} from './customerSignals';
import {browserScope,browserScopePrefix} from './sessionScope';
import {randomId} from './randomId';
// Browser-local drafts: never change the operational assignment until confirmation.
const DRAFT_PREFIX='autotu:handover:v2:';
export function draftKey(api, userId, assignmentId, mode, tenantId) {
  return `${DRAFT_PREFIX}${JSON.stringify(browserScope(api,userId,tenantId,assignmentId,mode))}`;
}
// Logout: drafts may hold a customer's signature. Remove every handover draft
// (any version, archived copies included) and customer-signal draft of this account.
export function clearUserDrafts(storage, api, user) {
  const scope=browserScopePrefix(api,user?.id,user?.tenant_id);
  const owned=key=>/^autotu:(?:handover|customer-signal):v\d+:(.*)$/s.exec(key||'')?.[1].startsWith(scope);
  const keys=[];
  for(let index=0;index<storage.length;index++){const key=storage.key(index);if(owned(key))keys.push(key);}
  keys.forEach(key=>storage.removeItem(key));
  if(keys.length)window.dispatchEvent(new Event(DRAFTS_CHANGED));
}
export function assignmentStamp(a, context = {}) {
  return JSON.stringify([a.id,a.vehicle_id,a.status,a.updated_at||'',a.km_start??null,a.start_date,a.start_at||'',a.end_date_planned,{signature_protocol:2,dispatch_revision:context.dispatchRevision,operation:context.operation}]);
}
export function readDraft(storage,key) {
  const raw=storage.getItem(key);
  if(raw==null)return null;
  const draft=JSON.parse(raw);
  if(draft?.version!==1||typeof draft.revision!=='string'||typeof draft.stamp!=='string'||!Number.isInteger(draft.step)||draft.step<0||draft.step>4||!draft.form||typeof draft.form.signature!=='string'||!Array.isArray(draft.form.photos)||typeof draft.form.checklist!=='object'||draft.form.checklist===null)throw new Error('Bozza non leggibile. Non è stata sovrascritta.');
  const f=draft.form;
  if(!['string','number'].includes(typeof f.km)||!['fuel','notes','return_date','return_time','return_fold'].every(k=>typeof f[k]==='string')||!f.photos.every(p=>p&&typeof p.path==='string')||!Object.values(f.checklist).every(v=>typeof v==='boolean')||(f.signature&&!f.signature.startsWith('data:image/')))throw new Error('Dati della bozza non validi. Non sono stati sovrascritti.');
  if(f.damage_zone!==undefined&&typeof f.damage_zone!=='string')throw new Error('Zona della bozza non valida.');
  if(f.damage_items!==undefined&&(!Array.isArray(f.damage_items)||!f.damage_items.every(d=>d&&['id','zone','type','description'].every(k=>typeof d[k]==='string')&&Array.isArray(d.photos)&&d.photos.every(p=>p&&typeof p.path==='string'))))throw new Error('Rilievi della bozza non leggibili. Non sono stati sovrascritti.');
  if(f.return_request_id!==undefined&&typeof f.return_request_id!=='string')throw new Error('Conferma della bozza non valida.');
  if(f.customer_signal!==undefined&&(!validSignalDraft(f.customer_signal)||typeof f.customer_signal.enabled!=='boolean'))throw new Error('Segnalazione della bozza non leggibile. Non è stata sovrascritta.');
  if(f.signature_protocol!==2||(!f.client_signer||!['name','capacity','title'].every(k=>typeof f.client_signer[k]==='string')||typeof (f.delivery_request_id||f.return_request_id)!=='string'))throw new Error('Dati del firmatario della bozza non leggibili.');
  return draft;
}
export function writeDraft(storage,key,{form,step,stamp},expectedRevision) {
  const current=readDraft(storage,key);
  if((current?.revision??null)!==expectedRevision)throw new Error('La bozza è cambiata in un’altra scheda. Ricarica per recuperare la versione salvata.');
  const draft={version:1,revision:randomId(),savedAt:new Date().toISOString(),stamp,step,form};
  storage.setItem(key,JSON.stringify(draft));
  return draft;
}
export function removeDraft(storage,key,expectedRevision) {
  const current=readDraft(storage,key);
  if((current?.revision??null)!==expectedRevision)throw new Error('La bozza è cambiata in un’altra scheda. Ricarica prima di eliminarla.');
  storage.removeItem(key);
}

export const DRAFTS_CHANGED = 'autotu:handover-drafts-changed';
const lockName = key => `autotu:handover-edit:${key}`;
export function holdDraftLock(key, onStatus) {
  let stopped=false, release;
  const held=new Promise(resolve=>{release=resolve;});
  if(!navigator.locks?.request){onStatus('Questo browser non supporta la protezione delle bozze tra schede. Apri il gestionale in un browser aggiornato.');return ()=>{};}
  // Skip effects abandoned by StrictMode before requesting the editor lock.
  Promise.resolve().then(()=>{if(stopped)return;return navigator.locks.request(lockName(key),{mode:'exclusive',ifAvailable:true},async lock=>{
    if(stopped)return;
    if(!lock){onStatus('Questa bozza è aperta in un’altra scheda. Chiudila lì e riapri il verbale.');return;}
    onStatus('');await held;
  });}).catch(()=>{if(!stopped)onStatus('Impossibile proteggere la bozza tra schede. Chiudi e riapri il verbale.');});
  return ()=>{stopped=true;release();};
}
export function removeDraftSnapshot(storage,key,expectedRaw) {
  if(storage.getItem(key)!==expectedRaw)throw new Error('La bozza è cambiata in un’altra scheda. Riapri la conferma prima di scartarla.');
  storage.removeItem(key);
  window.dispatchEvent(new Event(DRAFTS_CHANGED));
}
export async function discardListedDraft(storage,key,expectedRaw) {
  if(!navigator.locks?.request)throw new Error('Apri la bozza in un browser aggiornato per scartarla in sicurezza.');
  return navigator.locks.request(lockName(key),{mode:'exclusive',ifAvailable:true},lock=>{
    if(!lock)throw new Error('La bozza è aperta in un’altra scheda. Termina caricamenti o conferme e chiudi quel verbale prima di scartarla.');
    removeDraftSnapshot(storage,key,expectedRaw);
  });
}
